import React from "react";
import { Link } from "react-router-dom";
import FrontendLayout from "../../components/frontend/FrontendLayout";

const PrivacyPolicy: React.FC = () => {
  return (
    <FrontendLayout>
      <section
        className="flat-title style-2 mb-4 tf-spacing-1"
        style={{ background: "#f9e7e4" }}
      >
        <div className="tf-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-inner mb-0 pt-0 d-flex justify-content-between">
                <ul className="breadcrumb">
                  <li>
                    <Link to="/" className="home fw-6 text-color-3">
                      Home
                    </Link>
                  </li>
                  <li>Privacy Policy</li>
                </ul>
                <h5 className="mt-3">Privacy Policy</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-box-team style-2 tf-spacing-1 pb-0">
        <div className="tf-container tf-spacing-1 pt-0">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="wg-property box-amenities border-0 p-0">
                <h4 className="title mb-4">Privacy Policy</h4>
                <div className="wrap-feature">
                  <div className="box-feature">
                    <ul>
                      <li className="feature-item">
                        We may use IP address to help diagnose problems with our server, and to administer our Web site. Your IP address may be also used to gather broad demographic information.
                      </li>
                      <li className="feature-item">
                        MyLandMart contains links to other websites. Orimark is not responsible for the privacy practices or the content of such Web sites.
                      </li>
                      <li className="feature-item">
                        We may use a third party ad company to display ads on MyLandMart (e.g. Google Adsense). These ads may contain cookies. While we may use cookies in other parts of our Web site, cookies received with banner ads are collected by our ad company, and we do not have access to this information.
                      </li>
                      <li className="feature-item">
                        Certifiable information is collected from users and/or registered members of MyLandMart which includes, but may not be limited to
                        <ul className="pt-2">
                          <li>Email address</li>
                          <li>Contact person name</li>
                          <li>User-created password</li>
                          <li>Mailing address</li>
                          <li>Pin code</li>
                          <li>Telephone number or other contact number</li>
                        </ul>
                      </li>
                      <li className="feature-item">
                        Except where you are explicitly informed, Orimark do not sell, rent, share, trade or give away any of your personal information.
                      </li>
                      <li className="feature-item">
                        MyLandMart may tie-up with partners to bring you various services. However, we will never share your personal information, without your explicit permission. Still, we encourage you to review the privacy policy of the partner for questions about their use, any personally identifiable information that you may separately submit to such partner.
                      </li>
                      <li className="feature-item">
                        If we change our privacy policy, we will prominently post a link to those changes on our Homepage so you are always aware of what information we collect, how we use it, and under what circumstances, if any, we disclose it. If at any point we decide to use personally identifiable information in a manner materially different from that stated at the time it was collected, we will notify you by way of an email. We will give you a choice as to whether or not we can use information in this different manner and act accordingly.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </FrontendLayout>
  );
};

export default PrivacyPolicy;